export default {
  OK: "ঠিক আছে",
  ok: "ঠিক আছে",
  loginFailed: "লগইন ব্যর্থ হয়েছে, অনুগ্রহ করে আবার চেষ্টা করুন।",
  requestFailed: "অনুরোধ ব্যর্থ হয়েছে, অনুগ্রহ করে আপনার ইন্টারনেট সংযোগ পরীক্ষা করুন।",
  invalidLogin: "অবৈধ ব্যবহারকারীর নাম বা পাসওয়ার্ড।",
  thisFunctionExists: "এই ফাংশনটি ইতিমধ্যে বিদ্যমান।",
  thisFunctionNotAllowDelete: "এই ফাংশনটি মুছে ফেলার অনুমতি নেই।",
  thisFunctionNotExists: "এই ফাংশনটির অস্তিত্ব নেই।",
  targetFunctionIdRequired: "টার্গেট ফাংশন আইডি প্রয়োজন।",
  thisPageExists: "এই পৃষ্ঠাটি ইতিমধ্যে বিদ্যমান।",
  thisPageNotAllowDelete: "এই পৃষ্ঠাটি মুছে ফেলার অনুমতি নেই।",
  thisRoleExists: "এই ভূমিকাটি ইতিমধ্যে বিদ্যমান।",
  thisRoleNotAllowDelete: "এই ভূমিকাটি মুছে ফেলার অনুমতি নেই।",
  targetRoleIdRequired: "টার্গেট রোল আইডি প্রয়োজন।",
  invalidParameter: "অবৈধ প্যারামিটার",
  systemError: "সিস্টেম আপনার অনুরোধ প্রক্রিয়া করতে অক্ষম।",
  spErrorMessage: "এসপি বার্তা ত্রুটি (কোন ত্রুটি নির্ভর করে)",
  actionbyRequired: "বর্তমান ব্যবহারকারী প্রয়োজন।",
  sessionTokenRequired: "সেশন টোকেন আবশ্যক",
  functionIdRequired: "ফাংশন আইডি প্রয়োজন।",
  functionNameRequired: "ফাংশন নাম আবশ্যক।",
  newFunctionNameRequired: "ফাংশন নাম আবশ্যক।",
  pageIdRequired: "পৃষ্ঠা আইডি প্রয়োজন।",
  newPageIdRequired: "পৃষ্ঠা আইডি প্রয়োজন।",
  newPageNameRequired: "পৃষ্ঠার নাম আবশ্যক",
  targetPageIdRequired: "টার্গেট পেজ আইডি প্রয়োজন।",
  passwordRequired: "পাসওয়ার্ড প্রয়োজন",
  userNameRequired: "পুরো নাম আবশ্যক।",
  passwordValidation: "পাসওয়ার্ড অবশ্যই 6-20 অক্ষর এবং সংখ্যা(গুলি) এবং অক্ষর(গুলি) এর সংমিশ্রণ হতে হবে।",
  pageNumRequired: "পৃষ্ঠা নম্বর আবশ্যক।",
  pageSizeRequired: "পৃষ্ঠার আকার আবশ্যক।",
  roleIdRequired: "রোল আইডি প্রয়োজন",
  oldPasswordRequired: "বর্তমান পাসওয়ার্ড আবশ্যক।",
  userStatusRequired: "ব্যবহারকারীর স্থিতি আবশ্যক।",
  newRoleIdRequired: "রোল আইডি আবশ্যক।",
  newRoleNameRequired: "ভূমিকার নাম আবশ্যক।",
  startDateIsGteEndDate: "শুরুর তারিখ সমাপ্তির তারিখের চেয়ে বড়।",
  thisRoleNotExists: "এই ভূমিকার অস্তিত্ব নেই।",
  thisPageNotExists: "এই পৃষ্ঠাটির অস্তিত্ব নেই।",
  thisUserExists: "এই ব্যবহারকারী ইতিমধ্যে বিদ্যমান।",
  thisUserNotExists: "এই ব্যবহারকারীর অস্তিত্ব নেই।",
  thisUserBlackListed: "আপনার অ্যাকাউন্ট স্থগিত করা হয়েছে।",
  thisUserInactive: "আপনার অ্যাকাউন্ট নিষ্ক্রিয় করা হয়েছে।",
  thisUserBlocked: "আপনার অ্যাকাউন্ট অবরুদ্ধ করা হয়েছে।",
  thisUserNotActive: "আপনার অ্যাকাউন্ট নিষ্ক্রিয় করা হয়েছে।",
  InvalidPageFunction: "অবৈধ পৃষ্ঠা ফাংশন",
  invalidUser: "অবৈধ ব্যবহারকারী!",
  invalidToken: "অবৈধ সেশন!",
  NoUserAccessRight: "অনুমতি প্রত্যাখ্যান করা হয়েছে!",
  connection: "সংযোগ ত্রুটি",
  profileIdRequired: "প্রোফাইল আইডি প্রয়োজন।",
  packageIdRequired: "প্যাকেজ আইডি আবশ্যক।",
  fullNameMinThreeChar: "পুরো নামটিতে কমপক্ষে 3 টি অক্ষর থাকতে হবে।",
  accountIdMinThreeChar: "অ্যাকাউন্ট আইডিতে কমপক্ষে 3 টি অক্ষর থাকতে হবে।",
  searchCriteriaRequired: "অনুসন্ধানের মানদণ্ড প্রয়োজন।",
  affiliateIdRequired: "এজেন্ট আইডি আবশ্যক।",
  minDepositRequired: "ন্যূনতম আমানত আবশ্যক।",
  bonusRateRequired: "বোনাস রেট প্রয়োজন।",
  onlyAllowRejectDeposit: "শুধুমাত্র ডিপোজিট টিকিট প্রত্যাখ্যান করার অনুমতি দিন।",
  senderBankIdRequired: "প্রেরকের ব্যাংক আইডি আবশ্যক।",
  senderBankAccNoRequired: "প্রেরক ব্যাংক দুদক নং। প্রয়োজন আছে।",
  minFTDAmtNumOnly: "সর্বনিম্ন এফটিডি অ্যাএমটি কেবল সংখ্যাগুলি গ্রহণ করে।",
  maxFTDAmtNumOnly: "ম্যাক্স এফটিডি অ্যামট কেবল সংখ্যাগুলি গ্রহণ করে।",
  crmBasicCriteriaRequired: "মেম্বার আইডি / কন্টাক্ট ফোন / যোগাযোগের ইমেল / সাইনআপ করার তারিখ / শেষ লগইন তারিখ প্রয়োজন।",
  verifiedDateRangeAllowThreeMonths: "সাইনআপ তারিখের পরিসীমা শুধুমাত্র 3 মাস পর্যন্ত নির্বাচন করার অনুমতি দেয়।",
  lastLoginDateRangeAllowThreeMonths: "শেষ লগইন তারিখের পরিসীমা শুধুমাত্র 3 মাস পর্যন্ত নির্বাচন করার অনুমতি দেয়।",
  depositDateRangeAllowThreeMonths: "ডিপোজিট তারিখের পরিসীমা শুধুমাত্র 3 মাস পর্যন্ত নির্বাচন করার অনুমতি দেয়।",
  ftdDateRangeAllowThreeMonths: "এফটিডি তারিখের পরিসীমা কেবলমাত্র 3 মাস পর্যন্ত নির্বাচন করার অনুমতি দেয়।",
  ltdDateRangeAllowThreeMonths: "এলটিডি তারিখের পরিসীমা কেবলমাত্র 3 মাস পর্যন্ত নির্বাচন করার অনুমতি দেয়।",
  lastLoginDateEarlierThanVerifiedDate: "সাইনআপের তারিখের আগে শেষ লগইন তারিখ।",
  depositDateEarlierThanVerifiedDate: "সাইনআপের তারিখের আগে ডিপোজিটের তারিখ।",
  ftdDateEarlierThanVerifiedDate: "সাইনআপের তারিখের আগে এফটিডি তারিখ।",
  ltdDateEarlierThanVerifiedDate: "সাইনআপের তারিখের চেয়ে আগে লিমিটেড তারিখ।",
  ftdFromRequired: "তারিখ থেকে এফটিডি প্রয়োজন।",
  ftdToRequired: "এফটিডি টু ডেট প্রয়োজন।",
  ltdFromRequired: "তারিখ থেকে লিমিটেড প্রয়োজন।",
  ltdToRequired: "আজ অবধি লিমিটেড প্রয়োজন।",
  failedToLaunchPaymentGateway: "পেমেন্ট গেটওয়ে চালু করতে ব্যর্থ হয়েছে।",
  enTitleRequired: "ইএন শিরোনাম আবশ্যক।",
  enBodyRequired: "ইএন বডি প্রয়োজন।",
  enImageUrlRequired: "ইএন ইমেজ ইউআরএল প্রয়োজন।",
  enImageUrlDesktopRequired: "ইএন ডেস্কটপ ইমেজ ইউআরএল আবশ্যক",
  enAltRequired: "EN Alt আবশ্যক।",
  enHrefRequired: "ইএন এইচআরইএফ আবশ্যক।",
  resubmitTicketRequired: "টিকিট পুনরায় জমা দেওয়া প্রয়োজন।",
  withtholdBonusAndAmountGreaterThanZero: "বোনাস আটকে রাখুন এবং একই সময়ে শূন্যের চেয়ে বেশি হওয়া যাবে না।",
  maxWithdrawMultipleAndAmountGreaterThanZero: "সর্বাধিক উত্তোলন একাধিক এবং সর্বাধিক উত্তোলনের পরিমাণ একই সময়ে শূন্যের চেয়ে বেশি হতে পারে না।",
  serverBusy: "সার্ভার এখন ব্যস্ত। অনুগ্রহ করে আবার চেষ্টা করুন।",
  isRequired: "অনুগ্রহ করে একটি {fname} লিখুন।",
  isMinValue: "{fname} এর সর্বনিম্ন {fvalue} থাকতে হবে।",
  isMaxValue: "{fname} অবশ্যই {fvalue} এর চেয়ে কম বা সমান হতে হবে।",
  isMinLength: "{fname} এর অবশ্যই কমপক্ষে {fvalue} অক্ষর থাকতে হবে।",
  isMaxLength: "{fname} অবশ্যই {fvalue} অক্ষরের চেয়ে কম বা সমান হতে হবে।",
  isAlpha: "{fname} শুধুমাত্র বর্ণমালা গ্রহণ করুন।",
  isAlphaNum: "{fname} শুধুমাত্র বর্ণসাংখ্যিক বিষয়গুলি গ্রহণ করুন।",
  isNumeric: "{fname} শুধুমাত্র সংখ্যাগুলি গ্রহণ করে।",
  isEmail: "{fname} কেবলমাত্র বৈধ ইমেল ঠিকানাগুলি গ্রহণ করে।",
  isIpAddress: "{fname} শুধুমাত্র বৈধ IPv4 ঠিকানা গ্রহণ করে।",
  isSameAs: "{fname} অবশ্যই {fname2} এর মতো হতে হবে।",
  isUrl: "{fname} শুধুমাত্র ইউআরএল গ্রহণ করে।",
  containAlphaNum: "{fname} এর অবশ্যই কমপক্ষে একটি বর্ণমালা এবং একটি সংখ্যা থাকতে হবে।",
  alphaNumWithSpace: "{fname} শুধুমাত্র বর্ণসাংখ্যিক বিষয়গুলি গ্রহণ করুন।",
  isDecimal: "{fname} শুধুমাত্র সংখ্যাগুলি গ্রহণ করে।",
  isInteger: "{fname} শুধুমাত্র পূর্ণসংখ্যা গ্রহণ করে।",
  selectOption: "দয়া করে একটি {fname} নির্বাচন করুন",
  notSameAs: "{fname} এবং {fname2} এক হতে পারে না।",
  dateRangeAllowOneMonth: "তারিখের সীমা শুধুমাত্র 1 মাস পর্যন্ত নির্বাচন করার অনুমতি দেয়।",
  dateRangeAllowOneYear: "তারিখের সীমা শুধুমাত্র 1 বছর পর্যন্ত নির্বাচন করার অনুমতি দেয়।",
  greaterThanZero: "{fname} অবশ্যই শূন্যের চেয়ে বড় হতে হবে।",
  atLeastOneAuthority: "কমপক্ষে একটি কর্তৃপক্ষ নির্বাচন করতে হবে।",
  BLOCK: "আপনার অ্যাকাউন্ট অবরুদ্ধ করা হয়েছে।",
  SUSPEND: "আপনার অ্যাকাউন্ট স্থগিত করা হয়েছে।",
  CLOSE: "আপনার অ্যাকাউন্ট বন্ধ হয়ে গেছে।",
  RESETL: "আপনার অ্যাকাউন্ট রিসেট করা হয়েছে।",
  atLeastOneProvider: "কমপক্ষে একটি সরবরাহকারী নির্বাচন করতে হবে।",
  failedToGetResultUrl: "ফলাফলের ইউআরএল পেতে ব্যর্থ হয়েছে।",
  fileSizeValidation: "খুব বড়, সর্বাধিক আকার অনুমোদিত 1 এমবি",
  atLeastOnePaymentOption: "কমপক্ষে একটি পেমেন্ট অপশন নির্বাচন করতে হবে।",
  atLeastOnePaymentGateway: "কমপক্ষে একটি পেমেন্ট গেটওয়ে নির্বাচন করতে হবে।",
  dateRangeAllow31Days: "তারিখের সীমা শুধুমাত্র 31 দিন পর্যন্ত নির্বাচন করার অনুমতি দেয়।",
  dateRangeAllow31Months: "তারিখের পরিসীমা শুধুমাত্র 31 মাস পর্যন্ত নির্বাচন করার অনুমতি দেয়।",
  dateRangeAllow31Years: "তারিখের সীমা শুধুমাত্র 31 বছর পর্যন্ত নির্বাচন করার অনুমতি দেয়।",
  invalidCategory: "অবৈধ বিভাগ",
  noChanges: "কোনও পরিবর্তন নেই।",
  permissionDenied: "অনুমতি প্রত্যাখ্যান করা হয়েছে।",
  referralCodeRequired: "রেফারেল কোড আবশ্যক।",
  providerDescRequired: "সরবরাহকারীর বিবরণ প্রয়োজন।",
  marqueeContentRequired: "মার্কি সামগ্রী আবশ্যক।",
  bonusNameRequired: "বোনাস নাম আবশ্যক।",
  baseAmountRequired: "বেস অ্যামাউন্ট প্রয়োজন।",
  reviewIdRequired: "রিভিউ আইডি প্রয়োজন।",
  surveyIdRequired: "সার্ভে আইডি প্রয়োজন।",
  questionRequired: "প্রশ্ন প্রয়োজন।",
  iframeIdRequired: "আইফ্রেম আইডি প্রয়োজন।",
  bonusAmountRequired: "বোনাসের পরিমাণ আবশ্যক।",
  inboxIdRequired: "ইনবক্স আইডি আবশ্যক।",
  exchangedAmountRequired: "বিনিময়ের পরিমাণ প্রয়োজন।",
  baseRateRequired: "বেস রেট প্রয়োজন।",
  exchangeRateRequired: "বিনিময় হার প্রয়োজন।",
  baseCurrencyRequired: "বেস মুদ্রা প্রয়োজন।",
  exchangeCurrencyRequired: "এক্সচেঞ্জ কারেন্সি প্রয়োজন।",
  depositTypeRequired: "ডিপোজিটের ধরণ আবশ্যক।",
  nbRedepositRequired: "এনবি রিডিপোজিট প্রয়োজন।",
  bankOwnerRequired: "ব্যাংক মালিক প্রয়োজন।",
  autoSenderRequired: "স্বতঃপ্রেরক প্রয়োজন",
  isRecommendRequired: "সুপারিশ করা প্রয়োজন।",
  recipientBankIdRequired: "প্রাপকের ব্যাংক আইডি আবশ্যক।",
  recipientBankAccNoRequired: "প্রাপকের ব্যাংক অ্যাকাউন্ট নম্বর আবশ্যক।",
  accountBalanceRequired: "অ্যাকাউন্ট ব্যালেন্স প্রয়োজন।",
  incomingAmountThresholdRequired: "ইনকামিং অ্যামাউন্ট থ্রেশহোল্ড আবশ্যক।",
  incomingFrequencyThresholdRequired: "ইনকামিং ফ্রিকোয়েন্সি থ্রেশহোল্ড আবশ্যক।",
  outgoingAmountThresholdRequired: "বহির্গামী পরিমাণের থ্রেশহোল্ড প্রয়োজন।",
  outgoingFrequencyThresholdRequired: "আউটগোয়িং ফ্রিকোয়েন্সি থ্রেশহোল্ড প্রয়োজন।",
  bankAccTypeRequired: "ব্যাংক অ্যাকাউন্টের ধরণ আবশ্যক",
  packageRequired: "প্যাকেজ প্রয়োজন।",
  rtpRequired: "আরটিপি আবশ্যক।",
  domainIdRequired: "ডোমেন আইডি আবশ্যক।",
  buyOnBehalfRequired: "পক্ষ থেকে কিনতে হবে।",
  serviceProviderRequired: "পরিষেবা সরবরাহকারীর প্রয়োজন।",
  serverAccountRequired: "সার্ভার অ্যাকাউন্ট আবশ্যক।",
  nameServerRequired: "নাম সার্ভার প্রয়োজন।",
  socialLinkRequired: "সামাজিক লিঙ্ক প্রয়োজন।",
  newSocialPlatformRequired: "নতুন সামাজিক প্ল্যাটফর্ম প্রয়োজন।",
  attachmentPathRequired: "সংযুক্তির পথ আবশ্যক।",
  depositMethodRequired: "ডিপোজিট পদ্ধতি প্রয়োজন।",
  depositDateRequired: "ডিপোজিটের তারিখ আবশ্যক।",
  refNoRequired: "রেফারেন্স নম্বর প্রয়োজন।",
  withdrawalAmountRequired: "প্রত্যাহারের পরিমাণ আবশ্যক।",
  targetBankAccNoRequired: "টার্গেট ব্যাংক অ্যাকাউন্ট নম্বর আবশ্যক।",
  targetBankIdRequired: "টার্গেট ব্যাংক আইডি প্রয়োজন।",
  jsonRatingRequired: "JSON রেটিং আবশ্যক।",
  startTimeRequired: "শুরুর সময় আবশ্যক।",
  accountIdRequired: "অ্যাকাউন্ট আইডি আবশ্যক।",
  parentIdRequired: "প্যারেন্ট আইডি আবশ্যক।",
  amountRequired: "পরিমাণ প্রয়োজন।",
  clientIpRequired: "ক্লায়েন্ট আইপি প্রয়োজন।",
  auditByRequired: "দ্বারা নিরীক্ষা প্রয়োজন।",
  systemTypeRequired: "সিস্টেমের ধরণ আবশ্যক।",
  currencyRequired: "মুদ্রা প্রয়োজন।",
  ipAddressRequired: "আইপি ঠিকানা আবশ্যক।",
  affiliateCodeRequired: "এজেন্ট কোড আবশ্যক।",
  contactPhoneRequired: "যোগাযোগের ফোন আবশ্যক",
  requestTypeRequired: "অনুরোধের ধরণ আবশ্যক",
  securityDisabledRequired: "নিরাপত্তা নিষ্ক্রিয় করা আবশ্যক।",
  gameCodeRequired: "গেম কোড আবশ্যক",
  seqRequired: "সিকোয়েন্স প্রয়োজন।",
  minLimitRequired: "সর্বনিম্ন সীমা আবশ্যক।",
  maxLimitRequired: "সর্বাধিক সীমা আবশ্যক।",
  commSportsRequired: "ক্রীড়া কমিশন প্রয়োজন।",
  commSlotsRequired: "স্লটের জন্য কমিশন প্রয়োজন।",
  commLivecasinoRequired: "লাইভ ক্যাসিনোর জন্য কমিশন প্রয়োজন।",
  commCockfightRequired: "মোরগের লড়াইয়ের জন্য কমিশন প্রয়োজন।",
  commOthersRequired: "অন্যদের জন্য কমিশন প্রয়োজন।",
  settingValueRequired: "মান নির্ধারণ করা প্রয়োজন।",
  vipIdRequired: "ভিআইপি আইডি আবশ্যক।",
  carryOverRequired: "ক্যারি ওভার প্রয়োজন।",
  campaignIdRequired: "ক্যাম্পেইন আইডি আবশ্যক।",
  titleRequired: "শিরোনাম প্রয়োজন।",
  bodyRequired: "দেহ প্রয়োজন।",
  itemOrderRequired: "আইটেম অর্ডার প্রয়োজন।",
  imageUrlRequired: "চিত্রের ইউআরএল আবশ্যক।",
  bannerIdRequired: "ব্যানার আইডি প্রয়োজন।",
  directionRequired: "নির্দেশনা প্রয়োজন।",
  defaultOrderRequired: "ডিফল্ট অর্ডার প্রয়োজন।",
  altRequired: "অল্ট পাঠ্য প্রয়োজন।",
  hrefRequired: "Href আবশ্যক।",
  targetWindowRequired: "টার্গেট উইন্ডো আবশ্যক।",
  loginRequiredRequired: "লগইন আবশ্যক",
  activeFromRequired: "থেকে সক্রিয় আবশ্যক।",
  activeToRequired: "অ্যাক্টিভ টু আবশ্যক",
  bannerTypeRequired: "ব্যানারের ধরণ আবশ্যক।",
  pageNameRequired: "পৃষ্ঠার নাম আবশ্যক",
  remarkRequired: "মন্তব্য প্রয়োজন।",
  settingKeyRequired: "সেটিং কী আবশ্যক",
  memberListRequired: "সদস্যের তালিকা আবশ্যক।",
  memberIdRequired: "মেম্বার আইডি আবশ্যক।",
  workingMonthRequired: "কাজের মাস আবশ্যক।",
  workingDateRequired: "কাজের তারিখ প্রয়োজন।",
  tacRequired: "শর্তাবলী আবশ্যক",
  paymentModeRequired: "পেমেন্ট মোড আবশ্যক।",
  newPasswordRequired: "নতুন পাসওয়ার্ড প্রয়োজন।",
  loginIdRequired: "লগইন আইডি আবশ্যক।",
  securityTagRequired: "সিকিউরিটি ট্যাগ আবশ্যক",
  securityCodeRequired: "সিকিউরিটি কোড আবশ্যক।",
  providerCodeRequired: "সরবরাহকারীর কোড প্রয়োজন।",
  startDateRequired: "শুরুর তারিখ আবশ্যক।",
  endDateRequired: "সমাপ্তির তারিখ আবশ্যক।",
  searchIdRequired: "সার্চ আইডি প্রয়োজন।",
  authTokenRequired: "অথ টোকেন প্রয়োজন।",
  newStatusRequired: "নতুন স্ট্যাটাস আবশ্যক।",
  actionRequired: "অ্যাকশন প্রয়োজন।",
  promotionIdRequired: "প্রচার আইডি প্রয়োজন।",
  promotionNameRequired: "প্রচারের নাম আবশ্যক।",
  rolloverRequired: "রোলওভার প্রয়োজন।",
  criteriaRequired: "মানদণ্ড প্রয়োজন।",
  ticketIdRequired: "টিকিট আইডি প্রয়োজন।",
  resultIdRequired: "রেজাল্ট আইডি প্রয়োজন।",
  bankIdRequired: "ব্যাংক আইডি প্রয়োজন।",
  bankAccNoRequired: "ব্যাংক অ্যাকাউন্ট নম্বর আবশ্যক।",
  bankAccHolderRequired: "ব্যাংক অ্যাকাউন্ট হোল্ডার প্রয়োজন।",
  newBankIdRequired: "নতুন ব্যাংক আইডি প্রয়োজন।",
  newBankAccNoRequired: "নতুন ব্যাংক অ্যাকাউন্ট নম্বর আবশ্যক।",
  newBankAccHolderRequired: "নতুন ব্যাংক অ্যাকাউন্ট হোল্ডার প্রয়োজন।",
  fullNameRequired: "পুরো নাম আবশ্যক।",
  depositAmountRequired: "ডিপোজিটের পরিমাণ প্রয়োজন।",
  gatewayAccRequired: "গেটওয়ে অ্যাকাউন্ট আবশ্যক।",
  labelNameRequired: "লেবেলের নাম আবশ্যক",
  labelIdRequired: "লেবেল আইডি আবশ্যক।",
  bankTypeRequired: "ব্যাংকের ধরণ আবশ্যক।",
  amountLimitRequired: "পরিমাণের সীমা আবশ্যক।",
  currencyRateRequired: "মুদ্রার হার প্রয়োজন।",
  urlRequired: "ইউআরএল আবশ্যক",
  cashRequired: "নগদ প্রয়োজন।",
  csRequired: "গ্রাহক সহায়তা প্রয়োজন।",
  vipNameRequired: "ভিআইপি নাম আবশ্যক",
  campaignNameRequired: "প্রচারাভিযানের নাম আবশ্যক।",
  transferIdRequired: "ট্রান্সফার আইডি প্রয়োজন।",
  betTimeRequired: "বাজি ধরার সময় প্রয়োজন।",
  turnoverRequired: "টার্নওভার প্রয়োজন।",
  payoutRequired: "পেআউট প্রয়োজন।",
  winloseRequired: "জয়/পরাজয় প্রয়োজন।",
  rawMessageRequired: "কাঁচা বার্তা আবশ্যক।",
  authStatusRequired: "অথ স্ট্যাটাস আবশ্যক।",
  dateRequired: "তারিখ প্রয়োজন।",
  betIdRequired: "বাজি আইডি আবশ্যক।",
  betStatusRequired: "বাজি স্ট্যাটাস আবশ্যক।",
  betAmountRequired: "বাজির পরিমাণ আবশ্যক।",
  isParlayRequired: "কি পার্লে প্রয়োজন।",
  isAddonRequired: "অ্যাডঅন কি প্রয়োজন।",
  withholdBonusRequired: "উইথহোল্ড বোনাস প্রয়োজন।",
  withholdAmountRequired: "আটকে রাখার পরিমাণ প্রয়োজন।",
  maxWithdrawAmountRequired: "সর্বাধিক উত্তোলনের পরিমাণ প্রয়োজন।",
  betTypeRequired: "বাজির ধরন আবশ্যক।",
  maxWithdrawMultipleRequired: "সর্বাধিক উত্তোলন একাধিক প্রয়োজন।",
  socialPlatformRequired: "সোশ্যাল প্ল্যাটফর্ম প্রয়োজন।",
  vipProviderRebateRequired: "ভিআইপি সরবরাহকারীর ছাড় প্রয়োজন।",
  selfRebateRateRequired: "স্ব-ছাড়ের হার প্রয়োজন।",
  downlineRebateRateRequired: "ডাউনলাইন ছাড়ের হার প্রয়োজন।",
  tierIdRequired: "টিয়ার আইডি আবশ্যক",
  rebateRateRequired: "ছাড়ের হার প্রয়োজন।",
  paymentGatewayRequired: "পেমেন্ট গেটওয়ে প্রয়োজন।",
  rescueIdRequired: "রেসকিউ আইডি প্রয়োজন।",
  rescueNameRequired: "উদ্ধারের নাম আবশ্যক।",
  rescueCycleRequired: "উদ্ধার চক্র প্রয়োজন।",
  minLoseRequired: "সর্বনিম্ন ক্ষতি প্রয়োজন।",
  rescueRateRequired: "রেসকিউ রেট প্রয়োজন।",
  maxPayoutRequired: "সর্বাধিক অর্থ প্রদান আবশ্যক।",
  payoutMethodRequired: "পেআউট পদ্ধতি প্রয়োজন।",
  targetGroupRequired: "টার্গেট গ্রুপ আবশ্যক।",
  maintainDepositRequired: "মেইনটেইন ডিপোজিট প্রয়োজন।",
  maintainTurnoverRequired: "টার্নওভার বজায় রাখা প্রয়োজন।",
  depositOrTurnoverRequired: "ডিপোজিট বা টার্নওভার প্রয়োজন।",
  maintainDepositOrMaintainTurnoverRequired: "ডিপোজিট বজায় রাখা বা টার্নওভার বজায় রাখা প্রয়োজন।",
  vipListRequired: "ভিআইপি তালিকা আবশ্যক।",
  gameNameRequired: "গেমের নাম আবশ্যক।",
  claimTypeRequired: "দাবির ধরণ আবশ্যক।",
  operatorIdRequired: "অপারেটর আইডি আবশ্যক।",
  maxBonusRequired: "সর্বোচ্চ বোনাস প্রয়োজন।",
  endTimeRequired: "শেষ সময় আবশ্যক।",
  mondayRequired: "সোমবার প্রয়োজন।",
  tuesdayRequired: "মঙ্গলবার প্রয়োজন।",
  wednesdayRequired: "বুধবার প্রয়োজন।",
  thursdayRequired: "বৃহস্পতিবার প্রয়োজন।",
  fridayRequired: "শুক্রবার প্রয়োজন।",
  saturdayRequired: "শনিবার প্রয়োজন।",
  sundayRequired: "রবিবার প্রয়োজন।",
  promotionTypeRequired: "প্রমোশনের ধরণ প্রয়োজন।",
  claimLimitRequired: "দাবির সীমা প্রয়োজন।",
  bonusRate1Required: "বোনাস রেট 1 আবশ্যক।",
  bonusRate1To2Required: "বোনাস হার 1 থেকে 2 আবশ্যক।",
  bonusRate1To3Required: "বোনাস রেট 1 থেকে 3 আবশ্যক।",
  bonusRate1To4Required: "বোনাস রেট 1 থেকে 4 আবশ্যক।",
  bonusRate1To5Required: "বোনাস রেট 1 থেকে 5 আবশ্যক।",
  bonusRate1To6Required: "বোনাস রেট 1 থেকে 6 আবশ্যক।",
  bonusRate1To7Required: "বোনাস রেট 1 থেকে 7 আবশ্যক।",
  externalIdRequired: "বাহ্যিক আইডি আবশ্যক।",
  opsiteRequired: "বিপরীত প্রয়োজন।",
  opsiteContentRequired: "বিপরীত সামগ্রী আবশ্যক।",
  opsiteLanguageRequired: "বিপরীত ভাষা প্রয়োজন।",
  opsitePaymentRequired: "বিপরীত পেমেন্ট প্রয়োজন।",
  opsiteProviderRequired: "বিপরীত সরবরাহকারীর প্রয়োজন।",
  opsiteProviderGamesRequired: "বিপরীত সরবরাহকারীর গেম আবশ্যক।",
  accountTypeRequired: "অ্যাকাউন্টের ধরণ আবশ্যক।",
  domainNameRequired: "ডোমেন নাম আবশ্যক।",
  settledTimeRequired: "সেটেন্ডেড টাইম প্রয়োজন।",
  validTurnoverRequired: "বৈধ টার্নওভার প্রয়োজন।",
  resultTimeRequired: "ফলাফলের সময় প্রয়োজন।",
  resultStatusRequired: "ফলাফলের স্থিতি আবশ্যক।",
  secondIdRequired: "দ্বিতীয় আইডি প্রয়োজন।",
  domainListRequired: "ডোমেন তালিকা আবশ্যক।",
  domainTypeRequired: "ডোমেন টাইপ আবশ্যক।",
  moduleRequired: "মডিউল প্রয়োজন।",
  gameIdRequired: "গেম আইডি আবশ্যক",
  gameDetailRequired: "গেমের বিশদ প্রয়োজন।",
  bonusRate1To8Required: "বোনাস রেট 1 থেকে 8 আবশ্যক।",
  bonusRate1To9Required: "বোনাস রেট 1 থেকে 9 আবশ্যক।",
  bonusRate1To10Required: "বোনাস রেট 1 থেকে 10 আবশ্যক।",
  invalidOrder: "অবৈধ আদেশ",
  bannerNotExists: "ব্যানারের অস্তিত্ব নেই।",
  invalidBannerType: "অবৈধ ব্যানারের ধরণ",
  pageNameExists: "পৃষ্ঠার নাম বিদ্যমান।",
  pageNotExists: "পৃষ্ঠার অস্তিত্ব নেই।",
  tacIsValid: "ওটিপি বৈধ।",
  invalidTac: "অবৈধ ওটিপি",
  tacExpired: "ওটিপির মেয়াদ শেষ হয়ে গেছে।",
  tacNotValidate: "ও.টি.পি যাচাই করা হয়নি।",
  paymentModeNotExists: "পেমেন্ট মোড বিদ্যমান নেই।",
  paymentOptionProviderNotExists: "পেমেন্ট অপশন প্রোভাইডারের অস্তিত্ব নেই।",
  ipAddressExists: "আইপি ঠিকানা বিদ্যমান।",
  ticketProcessed: "টিকিট প্রক্রিয়া করা হয়েছে।",
  bankAccountNotExists: "ব্যাংক অ্যাকাউন্টের অস্তিত্ব নেই।",
  bankAccountInactive: "ব্যাংক অ্যাকাউন্ট নিষ্ক্রিয়।",
  bankMemberNotExists: "ব্যাংক সদস্যের অস্তিত্ব নেই।",
  bankMemberInactive: "ব্যাংক সদস্য নিষ্ক্রিয়।",
  affiliateExists: "এজেন্টের অস্তিত্ব আছে।",
  contactPhoneExists: "যোগাযোগের ফোন বিদ্যমান।",
  affiliateFull: "এজেন্ট পূর্ণ",
  uplineInactive: "আপলাইন নিষ্ক্রিয়।",
  applicationProcessed: "আবেদন প্রক্রিয়া করা হয়েছে।",
  tacValidated: "বিধি ও শর্তাবলী যাচাই করা হয়েছে।",
  applicationPending: "আবেদন মুলতুবি রয়েছে।",
  favouriteGameExists: "প্রিয় গেম বিদ্যমান।",
  invalidLimit: "অবৈধ সীমা",
  settingNotSet: "সেটিং সেট করা হয়নি।",
  domainNameNotExists: "ডোমেইন নামের অস্তিত্ব নেই।",
  domainNameFull: "ডোমেন নাম পূর্ণ",
  domainNameNotAvailable: "ডোমেন নাম উপলভ্য নয়।",
  domainNameExists: "ডোমেইন নাম বিদ্যমান।",
  subAccountNotExists: "সাব-অ্যাকাউন্টের অস্তিত্ব নেই।",
  settingNotExists: "সেটিং বিদ্যমান নেই।",
  invalidContactEmail: "অবৈধ পরিচিতি ইমেল।",
  accountInactive: "অ্যাকাউন্ট নিষ্ক্রিয়।",
  campaignNotExists: "প্রচারাভিযানের অস্তিত্ব নেই।",
  paymentProviderNotExists: "পেমেন্ট সরবরাহকারীর অস্তিত্ব নেই।",
  profileInactive: "প্রোফাইল নিষ্ক্রিয়।",
  minWithdrawalNotMet: "ন্যূনতম প্রত্যাহার পূরণ হয়নি।",
  invalidBankId: "অবৈধ ব্যাংক আইডি।",
  bankAccountExists: "ব্যাংক অ্যাকাউন্ট বিদ্যমান।",
  bankAccountFull: "ব্যাংক অ্যাকাউন্ট পূর্ণ",
  bankAccHolderNotSame: "ব্যাংক অ্যাকাউন্ট হোল্ডার একই নয়।",
  exceedMaxWithdrawal: "সর্বাধিক উত্তোলন অতিক্রম করেছে।",
  exceedWithdrawalFrequency: "প্রত্যাহারের ফ্রিকোয়েন্সি অতিক্রম করে।",
  invalidPackage: "অবৈধ প্যাকেজ",
  promotionNotAvailable: "প্রচার উপলভ্য নয়।",
  ongoingPromotion: "চলমান প্রচার",
  pendingResultInGame: "খেলায় মুলতুবি ফলাফল।",
  labelNameExists: "লেবেলের নাম বিদ্যমান।",
  labelNotExists: "লেবেলের অস্তিত্ব নেই।",
  invalidFtdMin: "অবৈধ প্রথমবারের আমানত সর্বনিম্ন।",
  invalidFtdMax: "অবৈধ প্রথমবারের আমানত সর্বোচ্চ।",
  ftdMinGtFtdMax: "প্রথমবারের আমানত সর্বনিম্ন সর্বোচ্চের চেয়ে বেশি।",
  vipFull: "ভিআইপি পূর্ণ",
  invalidRewardType: "অবৈধ পুরষ্কারের ধরণ",
  vipExists: "ভিআইপি বিদ্যমান।",
  vipNotExists: "ভিআইপির অস্তিত্ব নেই।",
  onlyOneMaxWithdrawSetting: "কেবলমাত্র একটি সর্বাধিক প্রত্যাহার সেটিং অনুমোদিত।",
  onlyOneWithholdSetting: "কেবলমাত্র একটি উইথহোল্ড সেটিং অনুমোদিত।",
  campaignExists: "প্রচারাভিযান বিদ্যমান।",
  vipProviderNotExists: "ভিআইপি সরবরাহকারীর অস্তিত্ব নেই।",
  turnoverTierExists: "টার্নওভার স্তর বিদ্যমান।",
  turnoverTierFull: "টার্নওভার স্তর সর্বাধিক স্তর ছাড়িয়ে গেছে।",
  turnoverTierNotExists: "টার্নওভার স্তরের অস্তিত্ব নেই।",
  invalidSettingValue: "অবৈধ সেটিং মান।",
  turnoverTierNotSet: "টার্নওভার স্তর সেট করা হয়নি।",
  rebateProcessed: "রিবেট প্রক্রিয়াধীন।",
  invalidActionType: "অবৈধ অ্যাকশন টাইপ",
  invalidRescueCycle: "অবৈধ উদ্ধার চক্র।",
  invalidPayoutMethod: "অবৈধ অর্থ প্রদানের পদ্ধতি",
  invalidTargetGroup: "অবৈধ টার্গেট গ্রুপ",
  rescueExists: "উদ্ধার বিদ্যমান।",
  rescueNotExists: "উদ্ধারের অস্তিত্ব নেই।",
  walletExists: "মানিব্যাগ বিদ্যমান।",
  accountExists: "অ্যাকাউন্ট বিদ্যমান।",
  activeFromGtActiveTo: "সক্রিয়ের চেয়ে বৃহত্তর থেকে সক্রিয়।",
  accountNotExists: "অপারেটর আইডির অস্তিত্ব নেই।",
  invalidDeposit: "অবৈধ আমানত",
  invalidTurnover: "অবৈধ টার্নওভার।",
  providerCodeNotExists: "সরবরাহকারী কোডের অস্তিত্ব নেই।",
  gameNameExists: "গেমের নাম বিদ্যমান।",
  gameNameNotExists: "গেমের নাম বিদ্যমান নেই।",
  invalidAccountType: "অবৈধ অ্যাকাউন্টের ধরন",
  invalidLoginIdFormat: "অবৈধ লগইন আইডি ফর্ম্যাট",
  invalidReferralCode: "অবৈধ রেফারেল কোড",
  firstDepositNotMet: "প্রথম আমানত পূরণ হয়নি।",
  newbieNotMet: "নবাগতের প্রয়োজনীয়তা পূরণ হয়নি।",
  claimPromoOnlyOnce: "দাবি প্রচার শুধুমাত্র একবার।",
  promotionRequirementNotMet: "পদোন্নতির প্রয়োজনীয়তা পূরণ হয়নি।",
  withdrawalAmountLteWithholdAmount: "উইথহোল্ড পরিমাণের চেয়ে কম বা সমান প্রত্যাহারের পরিমাণ।",
  subAccountInactive: "সাব-অ্যাকাউন্ট নিষ্ক্রিয়।",
  gameNotSupported: "গেম সমর্থিত নয়।",
  startTimeGteEndTime: "শুরুর সময়টি শেষ সময়ের চেয়ে বেশি বা সমান।",
  invalidPromotionType: "অবৈধ প্রচারের ধরণ",
  invalidClaimType: "অবৈধ দাবির ধরন",
  claimLimitExceeded10: "দাবির সীমা 10 ছাড়িয়ে গেছে।",
  verificationFailed: "যাচাইকরণ ব্যর্থ হয়েছে।",
  claimLimitReached: "দাবির সীমায় পৌঁছেছে।",
  invalidPromotion: "অবৈধ প্রচার।",
  socialPlatformExists: "সামাজিক প্ল্যাটফর্ম বিদ্যমান।",
  duplicateReview: "ডুপ্লিকেট রিভিউ।",
  invalidSurveyId: "অবৈধ সমীক্ষা আইডি।",
  accountNotBlock: "অ্যাকাউন্ট অবরুদ্ধ করা হয়নি।",
  walletNotExists: "ওয়ালেটের অস্তিত্ব নেই।",
  socialPlatformNotExists: "সামাজিক প্ল্যাটফর্মের অস্তিত্ব নেই।",
  socialPlatformInactive: "সামাজিক প্ল্যাটফর্ম নিষ্ক্রিয়।",
  accountSocialExists: "সামাজিক অ্যাকাউন্ট বিদ্যমান।",
  invalidStatus: "অবৈধ অবস্থা",
  samePassword: "একই পাসওয়ার্ড",
  invalidPassword: "অবৈধ ব্যবহারকারীর নাম বা পাসওয়ার্ড।",
  secondaryAccountExists: "সেকেন্ডারি অ্যাকাউন্ট বিদ্যমান।",
  invalidSecurityCode: "অবৈধ সুরক্ষা কোড",
  accountSocialNotExists: "অ্যাকাউন্ট সামাজিক বিদ্যমান নেই।",
  providerInactive: "সরবরাহকারী নিষ্ক্রিয়।",
  gameIdExists: "গেম আইডি বিদ্যমান।",
  gameIdNotExists: "গেম আইডির অস্তিত্ব নেই।",
  parentProviderInactive: "অভিভাবক সরবরাহকারী নিষ্ক্রিয়।",
  betLimitNotExists: "বাজি সীমার অস্তিত্ব নেই।",
  min3Characters: "সর্বনিম্ন 3 টি অক্ষর।",
  invalidBankAccType: "অবৈধ ব্যাংক অ্যাকাউন্টের ধরণ",
  senderBankNotExists: "প্রেরক ব্যাংকের অস্তিত্ব নেই।",
  recipientBankNotExists: "প্রাপক ব্যাংকের অস্তিত্ব নেই।",
  affiliateNotExists: "এজেন্টের অস্তিত্ব নেই।",
  redepositedTicket: "রিডিপোজিট করা টিকিট",
  invalidDepositType: "অবৈধ আমানতের ধরণ",
  affiliateInactive: "এজেন্ট নিষ্ক্রিয়।",
  bonusUnavailable: "বোনাস অনুপলব্ধ।",
  pendingDeposit: "মুলতুবি আমানত।",
  noOngoingPromotion: "কোনও চলমান প্রচার নেই।",
  iframeNotExists: "IFrame এর অস্তিত্ব নেই।",
  gameMaintenance: "গেম রক্ষণাবেক্ষণ",
  labelInactive: "নিষ্ক্রিয় লেবেল",
  invalidDomainType: "অবৈধ ডোমেন টাইপ",
  invalidModule: "অবৈধ মডিউল",
  labelFull: "লেবেল পূর্ণ",
  questionExists: "প্রশ্ন বিদ্যমান।",
  questionFull: "প্রশ্ন পূর্ণ",
  questionNotExists: "প্রশ্নের অস্তিত্ব নেই।",
  reviewNotExists: "পর্যালোচনার অস্তিত্ব নেই।",
  invalidDomainGroup: "অবৈধ ডোমেন গ্রুপ।",
  invalidDateRange: "অবৈধ তারিখের সীমা।",
  ipAddressNotExists: "আইপি ঠিকানার অস্তিত্ব নেই।",
  marqueeNotExists: "মার্কির অস্তিত্ব নেই।",
  invalidAmount: "অবৈধ পরিমাণ",
  insufficientBalance: "অপর্যাপ্ত ভারসাম্য।",
  minLimitLtParent: "পিতামাতার চেয়ে সর্বনিম্ন সীমা কম।",
  maxLimitGtParent: "পিতামাতার চেয়ে সর্বাধিক সীমা বেশি",
  startDateGtEndDate: "সমাপ্তির তারিখের চেয়ে শুরুর তারিখ বড় হয়েছে।",
  currencyNotExists: "মুদ্রার অস্তিত্ব নেই।",
  currencyExists: "মুদ্রার অস্তিত্ব আছে।",
  noAccumulateWin: "কোনও সঞ্চিত জয় নেই।",
  invalidSession: "অবৈধ সেশন",
  sessionExpired: "সেশনের মেয়াদ শেষ হয়ে গেছে।",
  promotionExists: "প্রচার বিদ্যমান।",
  invalidCriteria: "অবৈধ মানদণ্ড",
  promotionNotExists: "প্রচারের অস্তিত্ব নেই।",
  ticketNotExists: "টিকিটের অস্তিত্ব নেই।",
  duplicateDebitRecord: "ডুপ্লিকেট ডেবিট রেকর্ড",
  duplicateCreditRecord: "ডুপ্লিকেট ক্রেডিট রেকর্ড",
  debitRecordNotExists: "ডেবিট রেকর্ডের অস্তিত্ব নেই।",
  minDepositNotMet: "ন্যূনতম আমানত পূরণ হয়নি।",
  duplicateBet: "ডুপ্লিকেট বাজি",
  invalidProviderCode: "অবৈধ সরবরাহকারী কোড",
  resultExists: "ফলাফল বিদ্যমান।",
  unableSPProcess: "সিস্টেম আপনার অনুরোধ প্রক্রিয়া করতে অক্ষম।",
  authRequired: "প্রমাণীকরণ কোড প্রয়োজন।",
  domainExists: "ডোমেন ইতিমধ্যে বিদ্যমান।",
  multiSelectOption: "অনুগ্রহ করে {fname} নির্বাচন করুন",
  invalidDomainFormat: "অবৈধ ডোমেন ফর্ম্যাট",
  noHttpHttps: "'https://' বা 'http://' অনুমোদিত নয়।",
  noReservedSubdomain: "সংরক্ষিত সাবডোমেইন অনুমোদিত নয়। অ্যাপ ডাউনলোড লিঙ্ক ব্যবহারের জন্য।",
  operatorInactive: "অপারেটর নিষ্ক্রিয়",
  invalidAccountIdFormat: "অবৈধ অ্যাকাউন্ট আইডি ফর্ম্যাট",
  contentIdRequired: "মেনু আইডি প্রয়োজন",
  themeCodeRequired: "থিম কোড প্রয়োজন",
  themeNameRequired: "থিমের নাম আবশ্যক",
  themeColorRequired: "থিমের রঙ প্রয়োজন",
  languageRequired: "ভাষা প্রয়োজন",
  positionRequired: "অবস্থান প্রয়োজন",
  themeContentIdRequired: "থিম সামগ্রী আইডি প্রয়োজন",
  emailRequired: "ইমেল প্রয়োজন",
  themeProviderTypeRequired: "থিম সরবরাহকারীর ধরণ আবশ্যক",
  phoneRequired: "ফোন প্রয়োজন",
  targetTypeRequired: "টার্গেট টাইপ আবশ্যক",
  packageTypeRequired: "প্যাকেজের ধরণ আবশ্যক",
  renewTermRequired: "পুনর্নবীকরণের মেয়াদ প্রয়োজন",
  packagePriceRequired: "প্যাকেজের মূল্য প্রয়োজন",
  packageStatusRequired: "প্যাকেজ স্ট্যাটাস প্রয়োজন",
  sortKeyRequired: "বাছাই কী আবশ্যক",
  invalidDomainStatus: "অবৈধ ডোমেন স্থিতি",
  invalidCurrency: "অবৈধ মুদ্রা",
  invalidThemeCode: "অবৈধ থিম কোড",
  invalidLanguage: "অবৈধ ভাষা",
  invalidPosition: "অবৈধ অবস্থান",
  invalidThemeContent: "অবৈধ থিম সামগ্রী",
  allParamsSameAsCurrent: "কোনও পরিবর্তন নেই",
  invalidThemeColor: "অবৈধ থিমের রঙ",
  invalidCartStatus: "অবৈধ কার্ট স্থিতি",
  invalidThemeProviderType: "অবৈধ থিম সরবরাহকারীর ধরণ",
  themeProviderTypeCannotBeUse: "থিম সরবরাহকারীর ধরণ ব্যবহার করা যাবে না",
  invalidUserStatus: "অবৈধ ব্যবহারকারীর স্থিতি",
  packageCannotBeRemove: "প্যাকেজটি অপসারণ করা যাবে না",
  userStatusIsAlrdSuspend: "ব্যবহারকারী ইতিমধ্যে স্থগিত করা হয়েছে",
  userStatusIsAlrdBlocked: "ব্যবহারকারী ইতিমধ্যে অবরুদ্ধ করা হয়েছে",
  userStatusIsAlrdActive: "ব্যবহারকারী ইতিমধ্যে সক্রিয়",
  invalidSortType: "অবৈধ বাছাই প্রকার",
  startDateBiggerThanEndDate: "শুরুর তারিখ সমাপ্তির তারিখের চেয়ে বড়",
  positionCannotBeUse: "অবস্থান ব্যবহার করা যাবে না",
  funcAddContentFailed: "সামগ্রী যোগ করতে ব্যর্থ হয়েছে",
  funcDeleteContentFailed: "সামগ্রী মুছতে ব্যর্থ হয়েছে",
  funcUpdateContentFailed: "সামগ্রী আপডেট করতে ব্যর্থ হয়েছে",
  funcAddThemeFailed: "থিম যোগ করতে ব্যর্থ হয়েছে",
  funcDeleteThemeFailed: "থিম মুছতে ব্যর্থ হয়েছে",
  funcUpdateThemeFailed: "থিম আপডেট করতে ব্যর্থ হয়েছে",
  funcAddThemeColorFailed: "থিমের রঙ যোগ করতে ব্যর্থ হয়েছে",
  funcDeleteThemeColorFailed: "থিমের রঙ মুছতে ব্যর্থ হয়েছে",
  funcUpdateThemeColorFailed: "থিমের রঙ আপডেট করতে ব্যর্থ হয়েছে",
  funcAddLanguageFailed: "ভাষা যোগ করতে ব্যর্থ হয়েছে",
  funcDeleteLanguageFailed: "ভাষা মুছতে ব্যর্থ হয়েছে",
  funcUpdateLanguageFailed: "ভাষা আপডেট করতে ব্যর্থ হয়েছে",
  funcAddThemeContentFailed: "থিম সামগ্রী যোগ করতে ব্যর্থ হয়েছে",
  funcDeleteThemeContentFailed: "থিম সামগ্রী মুছতে ব্যর্থ হয়েছে",
  funcUpdateThemeContentFailed: "থিম সামগ্রী আপডেট করতে ব্যর্থ হয়েছে",
  funcAddContentPositionFailed: "সামগ্রীর অবস্থান যোগ করতে ব্যর্থ হয়েছে",
  funcUpdateContentPositionFailed: "সামগ্রীর অবস্থান আপডেট করতে ব্যর্থ হয়েছে",
  funcDeleteContentPositionFailed: "সামগ্রীর অবস্থান মুছতে ব্যর্থ হয়েছে",
  funcAddThemeProviderTypeFailed: "থিম সরবরাহকারীর ধরণ যোগ করতে ব্যর্থ হয়েছে",
  funcUpdateThemeProviderTypeFailed: "থিম সরবরাহকারীর ধরণ আপডেট করতে ব্যর্থ হয়েছে",
  funcDeleteThemeProviderTypeFailed: "থিম সরবরাহকারীর ধরণ মুছতে ব্যর্থ হয়েছে",
  funcAddPackageFailed: "প্যাকেজ যোগ করতে ব্যর্থ হয়েছে",
  funcUpdatePackageFailed: "প্যাকেজ আপডেট করতে ব্যর্থ হয়েছে",
  funcDeletePackageFailed: "প্যাকেজ মুছতে ব্যর্থ হয়েছে",
  nicknameRequired: "ডাকনাম আবশ্যক",
  accountStatusRequired: "অ্যাকাউন্টের স্থিতি প্রয়োজন",
  contentIdMaxLength50: "মেনু আইডি সর্বাধিক দৈর্ঘ্য 50",
  positionMaxLength10: "অবস্থানের সর্বোচ্চ দৈর্ঘ্য 10",
  contentDescMaxLength200: "বিষয়বস্তুর বিবরণ সর্বাধিক দৈর্ঘ্য 200",
  domainStatusRequired: "ডোমেন স্ট্যাটাস প্রয়োজন",
  funcAddDomainFailed: "ডোমেন যোগ করতে ব্যর্থ হয়েছে",
  funcUpdateDomainFailed: "ডোমেন আপডেট করতে ব্যর্থ হয়েছে",
  uploadFailed: "আপলোড করা ব্যর্থ হয়েছে!",
  sortKeyMaxLength50: "বাছাই কী সর্বাধিক দৈর্ঘ্য 50",
  invalidSortTypeFormat: "অবৈধ বাছাই প্রকার ফর্ম্যাট",
  invalidPackageId: "অবৈধ প্যাকেজ আইডি",
  invalidAccountStatusFormat: "অবৈধ অ্যাকাউন্ট স্ট্যাটাস ফর্ম্যাট",
  invalidSiteStatusFormat: "অবৈধ সাইট স্ট্যাটাস ফর্ম্যাট",
  invalidPackageStatus: "অবৈধ প্যাকেজ স্থিতি",
  invalidEmailFormat: "অবৈধ ইমেল ফর্ম্যাট",
  invalidPhoneFormat: "অবৈধ ফোন ফর্ম্যাট",
  languageLengthNotInRange: "ভাষার দৈর্ঘ্য পরিসরে নয় (2-5)",
  languageDescriptionMaxLength50: "ভাষার বিবরণ সর্বোচ্চ দৈর্ঘ্য 50",
  remarkMaxLength500: "মন্তব্য সর্বোচ্চ দৈর্ঘ্য 500",
  themeProviderTypeMaxLength50: "থিম সরবরাহকারীর প্রকারের সর্বোচ্চ দৈর্ঘ্য 50",
  themeNameMaxLength50: "থিমের নাম সর্বাধিক দৈর্ঘ্য 50",
  themeColorMaxLength20: "থিম রঙের সর্বাধিক দৈর্ঘ্য 20",
  noSpace: "অবশ্যই স্থান থাকবে না",
  packageDescEnRequired: "নাম ইংরেজি প্রয়োজন",
  packageDescEnMaxLength20: "নাম ইংরেজি সর্বোচ্চ দৈর্ঘ্য 20",
  allParamsIsNull: "সমস্ত প্যারামিটার শূন্য",
  contentCannotBeRemove: "সামগ্রী অপসারণ করা যাবে না",
  contentDetailsRequired: "সামগ্রীর বিশদ প্রয়োজন",
  domainCannotBeUse: "ডোমেন ব্যবহার করা যাবে না",
  domainGroupMaxLength20: "ডোমেন গ্রুপের সর্বোচ্চ দৈর্ঘ্য 20",
  domainGroupRequired: "ডোমেন গ্রুপ প্রয়োজন",
  domainNameCannotUpdate: "ডোমেন নাম আপডেট করা যাবে না",
  domainNameMaxLength400: "ডোমেন নামের সর্বাধিক দৈর্ঘ্য 400",
  domainsRequired: "ডোমেনগুলি প্রয়োজন",
  domainStatusMaxLength20: "ডোমেন স্ট্যাটাস সর্বাধিক দৈর্ঘ্য 20",
  domainTypeMaxLength10: "ডোমেন টাইপ সর্বাধিক দৈর্ঘ্য 10",
  funcAddThemeContentGroupFailed: "থিম সামগ্রী গ্রুপ যুক্ত করতে ব্যর্থ হয়েছে",
  funcDeleteThemeContentGroupFailed: "থিম সামগ্রী গ্রুপ মুছতে ব্যর্থ হয়েছে",
  funcOpsiteUpdateFailed: "বিপরীত আপডেট ব্যর্থ হয়েছে",
  funcResetAccountPasswordFailed: "অ্যাকাউন্টের পাসওয়ার্ড রিসেট করতে ব্যর্থ হয়েছে",
  funcSiteLanguageUpsertFailed: "সাইটের ভাষা আপসার্ট ব্যর্থ হয়েছে",
  funcSiteThemeContentUpsertFailed: "সাইট থিম সামগ্রী আপসার্ট ব্যর্থ হয়েছে",
  funcSiteThemeUpsertFailed: "সাইট থিম আপসার্ট ব্যর্থ হয়েছে",
  funcSiteUpdateFailed: "সাইট আপডেট ব্যর্থ হয়েছে",
  funcUpdateAccountFailed: "অ্যাকাউন্ট আপডেট ব্যর্থ হয়েছে",
  funcUpdateAccountStatusActiveFailed: "অ্যাকাউন্টের স্থিতি সক্রিয় করতে ব্যর্থ হয়েছে",
  funcUpdateAccountStatusCompanyBlockFailed: "কোম্পানি ব্লকে অ্যাকাউন্টের স্থিতি আপডেট করা ব্যর্থ হয়েছে",
  funcUpdateAccountStatusSuspendFailed: "স্থগিত করার জন্য অ্যাকাউন্টের স্থিতি আপডেট করতে ব্যর্থ হয়েছে",
  funcUpdateThemeContentGroupFailed: "থিম সামগ্রী গ্রুপ আপডেট ব্যর্থ হয়েছে",
  invalidBoDomain: "অবৈধ বিও ডোমেন",
  invalidOperatorIdFormat: "অবৈধ অপারেটর আইডি ফর্ম্যাট",
  invalidOpsite: "অবৈধ বিপরীত",
  invalidOpsiteOperator: "অবৈধ বিপরীত অপারেটর",
  invalidOpsiteVersion: "অবৈধ বিপরীত সংস্করণ",
  invalidParentContentInGroup: "গ্রুপে অবৈধ পিতামাতার সামগ্রী",
  invalidSite: "অবৈধ সাইট",
  invalidSiteStatus: "অবৈধ সাইটের স্থিতি",
  invalidThemeContentGroup: "অবৈধ থিম সামগ্রী গ্রুপ",
  languageCannotBeUse: "ভাষা ব্যবহার করা যাবে না",
  languagesRequired: "ভাষা প্রয়োজন",
  logo1Required: "লোগো প্রয়োজন",
  notSupportMultiDefault: "মাল্টি-ডিফল্ট সমর্থিত নয়",
  operatorIdMaxLength50: "অপারেটর আইডি সর্বোচ্চ দৈর্ঘ্য 50",
  opsiteNotMatch: "বিপরীত মিলছে না",
  packageTypeMaxLength15: "প্যাকেজ টাইপ সর্বাধিক দৈর্ঘ্য 15",
  parentContentIdCannotSameWithContentId: "প্যারেন্ট কন্টেন্ট আইডি সামগ্রী আইডির মতো একই হতে পারে না",
  phoneNumberRequired: "ফোন নম্বর আবশ্যক",
  siteIdRequired: "সাইট আইডি প্রয়োজন",
  siteNameMaxLength50: "সাইটের নাম সর্বাধিক দৈর্ঘ্য 50",
  siteNameRequired: "সাইটের নাম আবশ্যক",
  technicalError: "প্রযুক্তিগত ত্রুটি",
  themeCannotBeRemove: "থিম অপসারণ করা যাবে না",
  themeCodeCannotBeUse: "থিম কোড ব্যবহার করা যাবে না",
  themeCodeMaxLength20: "থিম কোডের সর্বোচ্চ দৈর্ঘ্য 20",
  themeColorCannotBeRemove: "থিমের রঙ অপসারণ করা যাবে না",
  themeColorCannotBeUse: "থিমের রঙ ব্যবহার করা যাবে না",
  themeContentCannotBeUse: "থিম সামগ্রী ব্যবহার করা যাবে না",
  themeContentGroupCannotBeUse: "থিম সামগ্রী গ্রুপ ব্যবহার করা যাবে না",
  themeContentGroupDescriptionMaxLength50: "থিম সামগ্রী গ্রুপের বিবরণ সর্বাধিক দৈর্ঘ্য 50",
  themeContentGroupMaxLength20: "থিম সামগ্রী গ্রুপের সর্বাধিক দৈর্ঘ্য 20",
  themeContentGroupRequired: "থিম সামগ্রী গ্রুপ প্রয়োজন",
  themeNameCannotBeUse: "থিমের নাম ব্যবহার করা যাবে না",
  userHaventVerifyThisBefore: "ব্যবহারকারী এটি আগে যাচাই করেননি",
  isDefaultTrueRequired: "ভাষার অবশ্যই 1 ডিফল্ট থাকতে হবে",
  accountIdMaxLength50: "ব্যবহারকারীর আইডি সর্বোচ্চ দৈর্ঘ্য 50",
  headBodyScriptEitherOne: "দয়া করে হেড স্ক্রিপ্ট বা বডি স্ক্রিপ্ট লিখুন",
  alphaOrNum: "কেবল বর্ণমালা বা সংখ্যা হতে হবে",
  phoneValid: "দয়া করে একটি বৈধ ফোন নম্বর লিখুন",
  permittedAmountRequired: "অনুমোদিত পরিমাণ প্রয়োজন",
  ignoreRiskRequired: "ঝুঁকি উপেক্ষা করা প্রয়োজন",
  paymentDescRequired: "পেমেন্টের বিবরণ প্রয়োজন",
  gameTypeRequired: "গেমের ধরণ আবশ্যক",
  statusRequired: "স্ট্যাটাস প্রয়োজন",
  payoutIdRequired: "পেআউট আইডি প্রয়োজন",
  commNotExists: "কমিশনের অস্তিত্ব নেই",
  parentCommNotExists: "প্যারেন্ট কমিশনের অস্তিত্ব নেই",
  carryOverNotExists: "ক্যারি ওভারের অস্তিত্ব নেই",
  hotGameExists: "হট গেম ইতিমধ্যে বিদ্যমান",
  commSportsExceededParent: "ক্রীড়া কমিশন পিতামাতাকে ছাড়িয়ে গেছে",
  commSlotsExceededParent: "স্লটগুলির জন্য কমিশন পিতামাতাকে ছাড়িয়ে গেছে",
  commLivecasinoExceededParent: "লাইভ ক্যাসিনোর জন্য কমিশন পিতামাতাকে ছাড়িয়ে গেছে",
  commCockfightExceededParent: "মোরগের লড়াইয়ের জন্য কমিশন পিতামাতাকে ছাড়িয়ে গেছে",
  commOthersExceededParent: "পিতামাতার চেয়ে বেশি অন্যদের জন্য কমিশন",
  hotGameNotExists: "হট গেমের অস্তিত্ব নেই",
  noSecurityDeposit: "কোনও সুরক্ষা তহবিল নেই",
  exchangeRateNotExists: "বিনিময় হার বিদ্যমান নেই",
  insufficientSecurityDeposit: "অপর্যাপ্ত সুরক্ষা তহবিল",
  duplicateDomain: "ডুপ্লিকেট ডোমেন",
  contactEmailNotExists: "যোগাযোগের ইমেলের অস্তিত্ব নেই",
  featuredGameNotExists: "ফিচার গেমের অস্তিত্ব নেই",
  newGameNotExists: "নতুন গেমের অস্তিত্ব নেই",
  popularGameNotExists: "জনপ্রিয় গেমের অস্তিত্ব নেই",
  featuredGameExists: "ফিচার গেম ইতিমধ্যে বিদ্যমান",
  newGameExists: "নতুন গেম ইতিমধ্যে বিদ্যমান",
  popularGameExists: "জনপ্রিয় গেমটি ইতিমধ্যে বিদ্যমান",
  rebateNotExists: "ছাড়ের অস্তিত্ব নেই",
  riskyMember: "ঝুঁকিপূর্ণ সদস্য",
  ipRestricted: "আইপি সীমাবদ্ধ",
  notSupportedBank: "সমর্থিত ব্যাংক নয়।",
  requestTooFrequent: "অনুরোধ খুব ঘন ঘন হয়।",
  paymentOptionNotExists: "পেমেন্ট অপশন বিদ্যমান নেই।",
  earningIdRequired: "উপার্জন আইডি আবশ্যক।",
  ptOnRequired: "পিটি আবশ্যক।",
  ptRequired: "পিটি আবশ্যক।",
  userIdRequired: "ইউজার আইডি আবশ্যক",
  businessIdRequired: "বিজনেস আইডি আবশ্যক।",
  subAccountIdRequired: "সাব অ্যাকাউন্ট আইডি প্রয়োজন।",
  sourceAccountIdRequired: "সোর্স অ্যাকাউন্ট আইডি আবশ্যক।",
  targetAccountIdRequired: "টার্গেট অ্যাকাউন্ট আইডি আবশ্যক।",
  ticketTaken: "টিকিট নেওয়া হয়েছে",
  ticketNotTaken: "টিকিট নেওয়া হয়নি",
  invalidPt: "অবৈধ পিটি",
  topupIdRequired: "টপ আপ আইডি প্রয়োজন",
  promotionMemberLogNotExists: "প্রচার সদস্য লগের অস্তিত্ব নেই",
  paymentOptionInactive: "পেমেন্ট অপশন নিষ্ক্রিয়",
  invalidCartStatusFormat: "অবৈধ কার্ট স্ট্যাটাস ফর্ম্যাট",
  requestIncompleted: "'অনুরোধ অসম্পূর্ণ',",
  unknownError: "'অজানা ত্রুটি ঘটেছে',",
  cartIdRequired: "কার্ট আইডি প্রয়োজন",
  stepNameRequired: "পদক্ষেপের নাম আবশ্যক",
  invalidCart: "অবৈধ কার্ট",
  invalidStepName: "অবৈধ পদক্ষেপের নাম",
  cartHaventSetupComplete: "কার্ট সেটআপ সম্পূর্ণ হয়নি",
  funcCartCreateFailed: "কার্ট তৈরি করতে ব্যর্থ হয়েছে",
  funcCartUpdateFailed: "কার্ট আপডেট করতে ব্যর্থ হয়েছে",
  funcSiteCreateFailed: "সাইট তৈরি করতে ব্যর্থ হয়েছে",
  funcCartPurchasedUpdateFailed: "কেনা কার্ট আপডেট করতে ব্যর্থ হয়েছে",
  invalidPasswordFormat: "অবৈধ পাসওয়ার্ড ফর্ম্যাট",
  currencyCodeRequired: "মুদ্রা প্রয়োজন",
  funcCartLanguageUpsertFailed: "ফাংশন কার্ট ল্যাঙ্গুয়েজ আপসার্ট ব্যর্থ হয়েছে",
  invalidUserIdFormat: "অবৈধ ইউজার আইডি ফর্ম্যাট",
  operatorPasswordRequired: "অপারেটর পাসওয়ার্ড প্রয়োজন",
  funcCartOperatorInfoUpsertFailed: "ফাংশন কার্ট অপারেটর তথ্য আপসার্ট ব্যর্থ হয়েছে",
  invalidOperatorPasswordFormat: "অবৈধ অপারেটর পাসওয়ার্ড ফর্ম্যাট",
  operatorIdCannotBeUse: "অপারেটর আইডি ব্যবহার করা যাবে না",
  siteNameLengthNotInRange: "সাইটের নামের দৈর্ঘ্য সীমার মধ্যে নেই",
  userIdCannotBeUse: "ইউজার আইডি ব্যবহার করা যাবে না",
  siteIdAlrdExist: "সাইট আইডি ইতিমধ্যে বিদ্যমান",
  operatorIdAlrdExist: "অপারেটর আইডি ইতিমধ্যে বিদ্যমান",
  externalIdAlrdExist: "বাহ্যিক আইডি ইতিমধ্যে বিদ্যমান",
  opsiteContentAlrdExist: "সাইটের বিষয়বস্তু থিম সামগ্রী ইতিমধ্যে বিদ্যমান",
  opsiteLanguageAlrdExist: "সাইটের সামগ্রীর ভাষা ইতিমধ্যে বিদ্যমান",
  boAccountAlrdExist: "বিও অ্যাকাউন্ট ইতিমধ্যে বিদ্যমান",
  boAccountProfileAlrdExist: "বিও অ্যাকাউন্ট প্রোফাইল ইতিমধ্যে বিদ্যমান",
  boAccountLoginAlrdExist: "বিও অ্যাকাউন্ট লগইন ইতিমধ্যে বিদ্যমান",
  funcCartThemeCodeUpsertFailed: "কার্ট থিম আপসার্ট করতে ব্যর্থ হয়েছে",
  funcCartThemeColorUpsertFailed: "কার্টের রঙ আপসার্ট করতে ব্যর্থ হয়েছে",
  funcOpsiteCreateFailed: "সাইটের সামগ্রী তৈরি করতে ব্যর্থ হয়েছে",
  alphabetValid: "কমপক্ষে একটি বড় হাতের এবং ছোট হাতের অক্ষর থাকতে হবে",
  numberValid: "কমপক্ষে একটি নম্বর থাকতে হবে",
  symbolValid: "কমপক্ষে একটি প্রতীক থাকতে হবে",
  credentialNotSet: "শংসাপত্র সেট করা হয়নি",
  validBankAccFormat: "অবৈধ ব্যাংক অ্যাকাউন্ট নং। ফর্ম্যাট",
  moreThan: "{fname} অবশ্যই {fname2} এর চেয়ে কম বা সমান হতে হবে",
  lessThan: "{fname} অবশ্যই {fname2} এর চেয়ে বেশি বা সমান হতে হবে।",
  bankAccountNotAvailable: "ব্যাংক অ্যাকাউন্ট উপলভ্য নয়।",
  insufficientCredit: "অপর্যাপ্ত ক্রেডিট",
  enableRequired: "সক্ষম করা আবশ্যক",
  funcAddGameFailed: "গেম যোগ করতে ব্যর্থ হয়েছে।",
  funcAddGameRewardByBatchFailed: "ব্যাচ অনুসারে গেম পুরষ্কার যোগ করতে ব্যর্থ হয়েছে।",
  funcAddGameRewardFailed: "গেম পুরষ্কার যোগ করতে ব্যর্থ হয়েছে।",
  funcAddGameTemplateFailed: "গেম টেমপ্লেট যোগ করতে ব্যর্থ হয়েছে।",
  funcAddLayoutTemplateFailed: "লেআউট টেমপ্লেট যোগ করতে ব্যর্থ হয়েছে।",
  funcAddOperatorGameFailed: "অপারেটর গেম যোগ করতে ব্যর্থ হয়েছে।",
  funcAddOperatorMemberWalletFailed: "অপারেটর সদস্য ওয়ালেট যোগ করতে ব্যর্থ হয়েছে।",
  funcDeleteGameFailed: "গেম মুছতে ব্যর্থ হয়েছে।",
  funcDeleteGameRewardFailed: "গেম পুরষ্কার মুছতে ব্যর্থ হয়েছে।",
  funcDeleteGameTemplateFailed: "গেম টেমপ্লেট মুছতে ব্যর্থ হয়েছে।",
  funcDeleteLayoutTemplateFailed: "লেআউট টেমপ্লেট মুছতে ব্যর্থ হয়েছে।",
  funcDeleteOperatorGameFailed: "অপারেটর গেম মুছতে ব্যর্থ হয়েছে।",
  funcUpdateGameFailed: "গেম আপডেট করতে ব্যর্থ হয়েছে।",
  funcUpdateGameRewardFailed: "গেম পুরষ্কার আপডেট করতে ব্যর্থ হয়েছে।",
  funcUpdateGameTemplateFailed: "গেম টেমপ্লেট আপডেট করতে ব্যর্থ হয়েছে।",
  funcUpdateLayoutTemplateFailed: "লেআউট টেমপ্লেট আপডেট করতে ব্যর্থ হয়েছে।",
  funcUpdateOperatorGameFailed: "অপারেটর গেম আপডেট করতে ব্যর্থ হয়েছে।",
  gameCannotBeRemove: "গেমটি অপসারণ করা যাবে না।",
  gameNameCannotBeUse: "গেমের নাম ব্যবহার করা যাবে না",
  gameNameMaxLength150: "গেমের নাম অবশ্যই সর্বাধিক 150 টি অক্ষর হতে হবে।",
  gameRewardCannotBeUse: "গেম পুরষ্কার ব্যবহার করা যাবে না।",
  gameRewardLimitExceeded: "গেম পুরষ্কারের সীমা অতিক্রম করেছে।",
  gameTemplateExist: "গেম টেমপ্লেট ইতিমধ্যে বিদ্যমান।",
  gameTypeMaxLength20: "গেমের ধরণ অবশ্যই সর্বাধিক 20 টি অক্ষর হতে হবে।",
  invalidGame: "অবৈধ খেলা",
  invalidGameReward: "অবৈধ গেম পুরষ্কার।",
  invalidGameTemplate: "অবৈধ গেম টেমপ্লেট",
  invalidMemberWallet: "অবৈধ সদস্য ওয়ালেট",
  invalidOperatorGame: "অবৈধ অপারেটর গেম",
  invalidRewardProbability: "অবৈধ পুরষ্কারের সম্ভাব্যতা।",
  invalidTemplate: "অবৈধ টেমপ্লেট",
  maxGameRewardRequired: "সর্বাধিক গেম পুরষ্কার প্রয়োজন।",
  maxMiniGameRewardRequired: "সর্বাধিক মিনি-গেম পুরষ্কার প্রয়োজন।",
  memberWalletAlrdExist: "মেম্বার ওয়ালেট ইতিমধ্যে বিদ্যমান।",
  operatorGameCannotBeUse: "অপারেটর গেম ব্যবহার করা যাবে না।",
  operatorGameIdRequired: "অপারেটর গেম আইডি আবশ্যক।",
  rewardCodeMaxLength20: "পুরষ্কার কোডটি অবশ্যই সর্বাধিক 20 টি অক্ষরের হতে হবে।",
  rewardCodeRequired: "পুরষ্কার কোড আবশ্যক।",
  rewardCurrencyMaxLength5: "পুরষ্কারের মুদ্রা অবশ্যই সর্বাধিক 5 টি অক্ষরের হতে হবে।",
  rewardCurrencyRequired: "পুরষ্কারের মুদ্রা প্রয়োজন।",
  rewardDescriptionMaxLength100: "পুরষ্কারের বিবরণ অবশ্যই সর্বাধিক 100 টি অক্ষর হতে হবে।",
  rewardNameMaxLength50: "পুরষ্কারের নাম অবশ্যই সর্বাধিক 50 টি অক্ষর হতে হবে।",
  rewardProbabilityRequired: "পুরষ্কারের সম্ভাব্যতা প্রয়োজন।",
  rewardRequired: "পুরষ্কার প্রয়োজন।",
  selectedTemplateMaxLength30: "নির্বাচিত টেমপ্লেটটি অবশ্যই সর্বাধিক 30 টি অক্ষরের হতে হবে।",
  selectedTemplateRequired: "নির্বাচিত টেমপ্লেট আবশ্যক।",
  success: "সাফল্য",
  templateCannotBeRemove: "টেমপ্লেট অপসারণ করা যাবে না।",
  templateCodeCannotBeUse: "টেমপ্লেট কোড ব্যবহার করা যাবে না।",
  templateCodeMaxLength30: "টেমপ্লেট কোডটি অবশ্যই সর্বাধিক 30 টি অক্ষরের হতে হবে।",
  templateCodeRequired: "টেমপ্লেট কোড প্রয়োজন।",
  templateNameMaxLength50: "টেমপ্লেটের নাম অবশ্যই সর্বাধিক 50 টি অক্ষর হতে হবে।",
  tokenRequestRequired: "টোকেন অনুরোধ আবশ্যক।",
  tokenRequired: "টোকেন প্রয়োজন।",
  mustMoreThan: "{fname} অবশ্যই {fvalue} এর চেয়ে বেশি হতে হবে",
  mustMoreThanOrEqual: "{fname} অবশ্যই {fvalue} এর চেয়ে বেশি বা সমান হতে হবে",
  tokenInvalid: "'{key}-এ টোকেন ইনপুট অবৈধ',",
  cashInvalid: "'ক্যাশ ইনপুট {key}-এ অবৈধ',",
  atLeastOneRequired: "'কমপক্ষে একটি প্রয়োজন',",
  cash1To7Required: "'নগদ 1 থেকে 7 প্রয়োজন',",
  cash1To6Required: "'নগদ 1 থেকে 6 প্রয়োজন',",
  cash1To5Required: "'নগদ 1 থেকে 5 প্রয়োজন',",
  cash1To4Required: "'নগদ 1 থেকে 4 প্রয়োজন',",
  cash1To3Required: "'নগদ 1 থেকে 3 প্রয়োজন',",
  cash1To2Required: "'নগদ 1 থেকে 2 প্রয়োজন',",
  cash1Required: "'নগদ 1 প্রয়োজন',",
  token1To7Required: "'টোকেন 1 থেকে 7 প্রয়োজন',",
  token1To6Required: "'টোকেন 1 থেকে 6 প্রয়োজন',",
  token1To5Required: "'টোকেন 1 থেকে 5 প্রয়োজন',",
  token1To4Required: "'টোকেন 1 থেকে 4 প্রয়োজন',",
  token1To3Required: "'টোকেন 1 থেকে 3 প্রয়োজন',",
  token1To2Required: "'টোকেন 1 থেকে 2 প্রয়োজন',",
  token1Required: "'টোকেন 1 প্রয়োজন',",
  cycleRequired: "'সাইকেল প্রয়োজন',",
  targetAmountRequired: "'টার্গেট পরিমাণ প্রয়োজন',",
  gamifyIdRequired: "'পুরষ্কার আইডি প্রয়োজন',",
  gamifyMemberProcessed: "'পুরষ্কার সদস্য প্রক্রিয়া করা হয়েছে',",
  gamifyNotExists: "'পুরষ্কারের অস্তিত্ব নেই',",
  gamifyInactive: "'পুরষ্কার নিষ্ক্রিয়',",
  invalidCycle: "'অবৈধ চক্র',",
  memberIdMaxLength50: "সদস্য আইডি 50 টি অক্ষরের বেশি হওয়া উচিত নয়",
  funcAddGameWalletFreeCreditFailed: "গেম ওয়ালেটে বিনামূল্যে ক্রেডিট যুক্ত করতে ব্যর্থ হয়েছে",
  funcUpdateOperatorMemberWalletBalanceFailed: "অপারেটর সদস্য ওয়ালেট ব্যালেন্স আপডেট করতে ব্যর্থ হয়েছে",
  funcUpdateOperatorMemberWalletBalanceByFrozenFailed: "হিমায়িত পরিমাণ দ্বারা অপারেটর সদস্য ওয়ালেট ব্যালেন্স আপডেট করতে ব্যর্থ হয়েছে",
  mustHaveBothAlphaNumOnly: "কেবলমাত্র বর্ণমালা এবং সংখ্যা ব্যবহার করুন, প্রত্যেকটির কমপক্ষে একটি সহ।",
  setupGameRewardBeforeEnable: "এটি সক্ষম করার আগে দয়া করে গেম পুরষ্কারটি সেট আপ করুন।",
  rewardProbabilityMustNotAllZero: "পুরষ্কারের সম্ভাব্যতা সব শূন্য হওয়া উচিত নয়।",
  totalRewardProbabilityCannotOver100: "মোট পুরষ্কারের সম্ভাবনা 100 অতিক্রম করতে পারে না।",
  credential1To2Required: "শংসাপত্র 1 থেকে 2 আবশ্যক।",
  credential1To4Required: "শংসাপত্র 1 থেকে 4 আবশ্যক।",
  newRemarkRequired: "মন্তব্য প্রয়োজন।",
  notSupportedWithdrawalPG: "অসমর্থিত উত্তোলন পেমেন্ট গেটওয়ে",
  prizeInvalid: "{key} এ পুরস্কারের ইনপুটটি অবৈধ",
  exceedMaxCampaignCount: "সর্বাধিক লিডারবোর্ড ক্যাম্পেইনের সীমা অতিক্রম করেছে।",
  leaderboardCampaignEnded: "লিডারবোর্ড ক্যাম্পেইন শেষ হয়েছে।",
  leaderboardCampaignStarted: "লিডারবোর্ড ক্যাম্পেইন শুরু হয়েছে।",
  leaderboardCampaignSettled: "লিডারবোর্ড ক্যাম্পেইন নিষ্পত্তি হয়েছে।",
  pleaseSelectUpToNoPhone: "অনুগ্রহ করে সর্বাধিক {fname}টি ফোন নম্বর নির্বাচন করুন।",
  phoneNotAvailable: "ফোন নম্বর উপলব্ধ নয়।",
  batchExpired: "ব্যাচের মেয়াদ শেষ হয়েছে।",
  remarkNotSame: "মন্তব্য মেলে না।",
  partnerIdRequired: "পার্টনার আইডি প্রয়োজন।",
  partnerNotExists: "পার্টনার বিদ্যমান নয়।",
  urgencyRequired: "জরুরিতা প্রয়োজন।",
  groupSizeRequired: "গ্রুপের আকার প্রয়োজন।",
  inactiveDaysRequired: "নিষ্ক্রিয় দিনের সংখ্যা প্রয়োজন।",
  idRequired: "আইডি প্রয়োজন।",
  expiryRequired: "মেয়াদ শেষের তারিখ প্রয়োজন।",
  batchIdRequired: "ব্যাচ আইডি প্রয়োজন।",
  requestDateRequired: "অনুরোধের তারিখ প্রয়োজন।",
  requestByRequired: "অনুরোধকারী প্রয়োজন।",
  cpiIdRequired: "CPI আইডি প্রয়োজন।",
  assigneeRequired: "দায়িত্বপ্রাপ্ত ব্যক্তি প্রয়োজন।",
  phoneNotAvailable: "ফোন নম্বর উপলব্ধ নয়।",
  liveChatNotExists: "লাইভ চ্যাট বিদ্যমান নয়।",
  resultNotExists: "ফলাফল বিদ্যমান নয়।",
  lastLaunchFundTransfer: "সর্বশেষ ফান্ড ট্রান্সফার চালু হয়েছে।",
  alreadyRegistered: "ইতিমধ্যেই নিবন্ধিত।",
  invalidId: "অবৈধ আইডি।",
  batchExpired: "ব্যাচের মেয়াদ শেষ হয়েছে।",
  teleCalling: "টেলিফোন কলিং",
  invalidUrgency: "অবৈধ জরুরিতা।",
  appTypeRequired: "অ্যাপ্লিকেশন টাইপ প্রয়োজন।",
  invalidAppType: "অবৈধ অ্যাপ্লিকেশন টাইপ।",
  appLinkRequired: "অ্যাপ্লিকেশন লিংক প্রয়োজন।",
  invalidDomain: "অবৈধ ডোমেইন।",
  existEndDateGtEndDate: "বর্তমান শেষ তারিখ নতুন শেষ তারিখের চেয়ে পরের।",
  newRemark2Required: "নতুন মন্তব্য ২ প্রয়োজন।",
  remark2NotSame: "মন্তব্য ২ মেলে না।",
  remark2Required: "মন্তব্য ২ প্রয়োজন।",
  nameRequired: "নাম প্রয়োজন।",
  aiAssistantNotExists: "AI সহকারী বিদ্যমান নয়।",
  aiAssistantInactive: "AI সহকারী নিষ্ক্রিয়।",
  phoneStartWithVND: "ফোন নম্বরটি অবশ্যই 84 দিয়ে শুরু হতে হবে",
  otherActiveLiveChat: "আরেকটি সক্রিয় LiveChat রয়েছে",
  whiteLabelRequired: "White Label প্রয়োজন",
  invalidWhiteLabel: "অবৈধ White Label",
  baseRateDepositRequired: "বেস রেট ডিপোজিট প্রয়োজন",
  revisionRequired: "রিভিশন প্রয়োজন",
  typeDescRequired: "টাইপ বিবরণ প্রয়োজন",
  riskWeightRequired: "ঝুঁকির ওজন প্রয়োজন",
  linkageTypeRequired: "লিংকেজ টাইপ প্রয়োজন",
  valueRequired: "মান প্রয়োজন",
  baseRateWithdrawalRequired: "বেস রেট উত্তোলন প্রয়োজন",
  sourceIdRequired: "সোর্স আইডি প্রয়োজন",
  targetIdRequired: "টার্গেট আইডি প্রয়োজন",
  linkageTypeNotExists: "লিংকেজ টাইপ বিদ্যমান নেই",
  phoneStartWithMYR: "ফোন নম্বরটি অবশ্যই 60 দিয়ে শুরু হতে হবে",
  minWithdrawalAmount100: "ন্যূনতম উত্তোলনের পরিমাণ ১০০",
  invalidReward: "অবৈধ রিওয়ার্ড",
  noRow: "কোনো রো নেই",
  credentialRequired: "ক্রেডেনশিয়াল প্রয়োজন",
  settlementIdRequired: "সেটেলমেন্ট ID প্রয়োজন",
  settlementDateRequired: "সেটেলমেন্ট তারিখ প্রয়োজন",
  newCryptoAddressRequired: "নতুন ক্রিপ্টো ঠিকানা প্রয়োজন",
  cryptoAddressRequired: "ক্রিপ্টো ঠিকানা প্রয়োজন",
  settlementTypeRequired: "সেটেলমেন্ট টাইপ প্রয়োজন",
  chatProviderRequired: "চ্যাট প্রোভাইডার প্রয়োজন",
  countRequired: "সংখ্যা প্রয়োজন",
  voucherCodeRequired: "ভাউচার কোড প্রয়োজন",
  eventTypeRequired: "ইভেন্ট টাইপ প্রয়োজন",
  viewTypeRequired: "ভিউ টাইপ প্রয়োজন",
  actionTypeRequired: "অ্যাকশন টাইপ প্রয়োজন",
  thresholdRequired: "থ্রেশহোল্ড প্রয়োজন",
  missionIdRequired: "মিশন ID প্রয়োজন",
  ruleIdRequired: "রুল ID প্রয়োজন",
  aggregatorRequired: "এগ্রিগেটর প্রয়োজন",
  rebateIdRequired: "রিবেট ID প্রয়োজন",
  liveChatExists: "এই লাইভচ্যাট ইতিমধ্যে রয়েছে",
  triggerNotExists: "ট্রিগার নেই",
  missionRuleNotExists: "মিশন রুল নেই",
  invalidVoucherCode: "অবৈধ ভাউচার কোড",
  invalidRebateType: "অবৈধ রিবেট টাইপ",
  invalidSettlementType: "অবৈধ সেটেলমেন্ট টাইপ",
  missionNotExists: "মিশন নেই",
  settlementTypeNotExists: "সেটেলমেন্ট টাইপ নেই",
  parentTriggerInactive: "প্যারেন্ট ট্রিগার নিষ্ক্রিয়",
  parentMissionInactive: "প্যারেন্ট মিশন নিষ্ক্রিয়",
  missionRuleNotSet: "মিশন রুল সেট করা হয়নি",
  invalidCreditType: "অবৈধ ক্রেডিট টাইপ",
  cryptoDisabled: "ক্রিপ্টো নিষ্ক্রিয়",
  depositExists: "ডিপোজিট ইতিমধ্যে রয়েছে",
  parentSettlementTypeNotExists: "প্যারেন্ট সেটেলমেন্ট টাইপ নেই",
  accessControlNotExists: "অ্যাক্সেস কন্ট্রোল নেই",
  cryptoAccountFull: "ক্রিপ্টো অ্যাকাউন্ট পূর্ণ",
  cryptoAccountExists: "ক্রিপ্টো অ্যাকাউন্ট ইতিমধ্যে রয়েছে",
  cryptoAccountNotExists: "ক্রিপ্টো অ্যাকাউন্ট নেই",
  settlementNotAvailable: "সেটেলমেন্ট উপলব্ধ নয়",
  settlementProcessed: "সেটেলমেন্ট সম্পন্ন হয়েছে",
  cryptoAccountInactive: "ক্রিপ্টো অ্যাকাউন্ট নিষ্ক্রিয়",
  leadIdRequired: "লিড ID প্রয়োজন",
  failedToCreateFreeRound: "ফ্রি রাউন্ড তৈরি করতে ব্যর্থ হয়েছে।",
  failedToGetFreeRound: "ফ্রি রাউন্ড পেতে ব্যর্থ হয়েছে।",
  failedToGetFreeRoundGameList: "ফ্রি রাউন্ড গেম তালিকা পেতে ব্যর্থ হয়েছে।",
  tierFull: "স্তর পূর্ণ",
  tierNotExists: "স্তর বিদ্যমান নেই",
  ticketTypeRequired: "টিকিটের ধরন আবশ্যক",
  invalidTicketType: "অবৈধ টিকিটের ধরন",
  positionRequired: "অবস্থান আবশ্যক",
  invalidPosition: "অবৈধ অবস্থান",
  invalidBonusRate: "অবৈধ বোনাস হার",
  minRequired: "সর্বনিম্ন মান আবশ্যক",
  maxRequired: "সর্বোচ্চ মান আবশ্যক",
  minGtMax: "সর্বনিম্ন মান সর্বোচ্চ মানের চেয়ে বেশি।",
  sessionExists: "সেশন ইতিমধ্যে বিদ্যমান",
  sessionOverlaps: "সেশন ওভারল্যাপ হয়েছে",
  sessionIdRequired: "সেশন ID আবশ্যক",
  sessionNotExists: "সেশন বিদ্যমান নেই",
  nameExists: "নাম ইতিমধ্যে বিদ্যমান",
  sessionElapsed: "সেশনের সময় শেষ হয়েছে",
  validUrl: "অনুগ্রহ করে একটি বৈধ URL লিখুন",
  minBalanceNotMet: "ন্যূনতম ব্যালেন্স পূরণ হয়নি",
  validSlugFormat: "অবৈধ স্লাগ ফরম্যাট",

  failedToCancelFreeRound: "ফ্রি রাউন্ড বাতিল করতে ব্যর্থ হয়েছে।",
  failedToGetFreeRoundLineBet: "ফ্রি রাউন্ডের লাইন বেট পেতে ব্যর্থ হয়েছে।",
};